
// ES6 template literal tag which performs URI escaping
// Similar to https://www.npmjs.com/package/url-escape-tag, but the latter is not browser-compatible
export default (stringParts, ...substitutions) =>
    substitutions.reduce(
        (prev, cur, i) => prev + encodeURIComponent(cur) + stringParts[i + 1],
        stringParts[0]
    );
